import React, { useEffect } from 'react';
import { useFormContext } from 'react-hook-form';
import { useDispatch } from 'react-redux';
import KogAutoCompleteControlled from '@/main/components/shared/inputAutoComplete/autoCompleteControlled';

import { KeyValueDefault } from '@/main/models/common';
import {
  getDefaultCountryOptionDrop,
  getTranslateByKey,
  isNullUndefined,
  isValueQueryParams
} from '@/main/services/utils';

import { useDinamicFiltersMappingCodes } from './dinamicFiltersMappingCodes';
import { getCountriesUser, useCountryReducer } from '@/main/store/country';
import { ReasonFilterRequest } from '@/main/models/request';
import { ReasonTypeEnum } from '@/main/services/enum/ReasonEnum';
import { getReason, useReasonReducer } from '@/main/store/reason';
import { convertStringForBoolean } from '@/main/services/utilsString';
import KogInputTextControlledNew from '@/main/components/shared/inputText/inputTextControlledNew';

export const INITIAL_FORM_STATE_REASON_TOTAL_LOSS = {
  reasonTotalLoss: null as KeyValueDefault | null
};

export type IFormFiltersMappingTypeReasonTotalLoss = typeof INITIAL_FORM_STATE_REASON_TOTAL_LOSS;

interface IFiltersMappingTypeReasonTotalLossProps {}
function FiltersMappingTypeReasonTotalLoss({}: IFiltersMappingTypeReasonTotalLossProps) {
  const dispatch = useDispatch();
  const {
    isEdit,
    watcherCountry,
    keyReducer,
    isRequiredField
  } = useDinamicFiltersMappingCodes();
  const { reason: reasonReducer } = useReasonReducer();
  const { countriesUser: countryReducer } = useCountryReducer();

  const { control, resetField, setValue, watch } = useFormContext<
    IFormFiltersMappingTypeReasonTotalLoss
  >();

  useEffect(() => {
    if (countryReducer.data === null) dispatch(getCountriesUser());
  }, []);

  useEffect(() => {
    const countryUser = getDefaultCountryOptionDrop(countryReducer.data);
    if (countryUser === null) return;

    const requestReason: ReasonFilterRequest = {
      guidCountry: String(countryUser.key),
      idReasonType: ReasonTypeEnum.ClaimValuationTypeTotalLoss
    };
    dispatch(getReason(requestReason));
  }, [JSON.stringify(countryReducer.data)]);

  return (
    <>
      <KogAutoCompleteControlled
        id="id-mappingCode-select-reasonTotalLoss"
        nameCustom="reasonTotalLoss"
        name="reasonTotalLoss"
        isDefaultValueUnique
        label={getTranslateByKey('information.reason')}
        control={control}
        setValueCustom={setValue}
        options={reasonReducer.data}
        isLoading={reasonReducer.isLoading}
        rulesCustom={{ required: isRequiredField('reasonTotalLoss') }}
        required={isRequiredField('reasonTotalLoss')}
        onChangeCustom={option => {
          if (option === null) return;
        }}
      />
    </>
  );
}

export default FiltersMappingTypeReasonTotalLoss;
